var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 15C30 6.71468 23.2853 0 15 0C6.71468 0 0 6.71799 0 15C0 23.282 6.71799 30 15 30C23.282 30 30 23.2853 30 15ZM2.14286 15C2.14286 7.90115 7.8983 2.14286 15 2.14286C22.1017 2.14286 27.8571 7.8983 27.8571 15C27.8571 22.1017 22.0989 27.8571 15 27.8571C7.90115 27.8571 2.14286 22.0989 2.14286 15Z",
    fill: "#FFB600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1538 9.23077H12.6923V18.4615H19.6154V15H16.1538V9.23077Z",
    fill: "#FFB600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProgress);
export default __webpack_public_path__ + "static/media/icon_progress.e4eca570bd59acbddc519945b582b650.svg";
export { ForwardRef as ReactComponent };